import { styled } from '@mui/material/styles';
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import produce from 'immer';
import Skeleton from '@mui/material/Skeleton';

import { Avatar, Chip, Input, ListItem, ListItemAvatar, ListItemText, ListItemSecondaryAction, IconButton, Typography, Divider, CircularProgress, Tooltip } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import CloseIcon from '@mui/icons-material/Close';

const PREFIX = 'commentEditForm';

const classes = {
  root: `${PREFIX}-root`,
  progress: `${PREFIX}-progress`,
  avatarSection: `${PREFIX}-avatarSection`,
  inputSection: `${PREFIX}-inputSection`,
  inputRoot: `${PREFIX}-inputRoot`,
  buttons: `${PREFIX}-buttons`,
  button: `${PREFIX}-button`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.root}`]: {
		display:'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    //alignItems: 'center',
  },

  [`& .${classes.progress}`]: {
    textAlign: 'center',
  },

  [`& .${classes.avatarSection}`]: {
    padding: '10px',
    marginTop: '5px',
  },

  [`& .${classes.inputSection}`]: {
    padding: '5px',
    width: '100%',
  },

  [`& .${classes.inputRoot}`]: {
		fontSize: 14,
    width: '100%',
  },

  [`& .${classes.buttons}`]: {
    display: 'flex',
		justifyContent: 'flex-end',
  },

  [`& .${classes.button}`]: {
    marginLeft: theme.spacing(2),
  }
}));

export default (props) => {

	const root = useSelector(state => state.api).root;
	const user = useSelector(state => state.user);
	const dispatch = useDispatch();
	const [ input, setInput ] = useState('');
	const [ loading, setLoading ] = useState(false);
	const { updateContent, setIsEditFormClicked } = props;
  const [ comment, setComment ] = useState(props.comment);
  //const { text, hashtags, persontags } = comment;
  const commentId = comment._id;

	const handleEditFormCancle = () => {
		setIsEditFormClicked(false);
	};

	const handleEditSubmit = () => {
    if(input === '')return;
		setLoading(true);
		fetch(`${root}/api/comment/${comment._id}`, { 
			method: 'put', 
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({ text: input }), 
			credentials: 'include', 
		})
			.then(res => res.json())
			.then(json => {
				setLoading(false);
				console.log('comment submit success', json)
				updateContent(draft => {
					const index = draft.comments.findIndex(function(element){return element._id === commentId});
          draft.comments[index].text = input;
				})
				handleEditFormCancle();
			})
			.catch(err => console.log(err))
	};

  /*
  const pullHashtag = hashtag => {
    setHashtags(hashtags.filter(el => el.name !== hashtag.name));
  }
  const pullPersontag = persontag => {
    setPersontags(persontags.filter(el => el.username !== persontag.username ));
    setInput(input.replace(activeWord, ''));
  }
  */

  return (
    <Root>
        { 
    loading
            ?
      <div className={classes.root}>
        <div className={classes.avatarSection}>
          <Skeleton animation="wave" variant="circular" width={40} height={40} />
        </div>
                    <div style={{width: '100%', margin: '5px', paddingTop: '20px', alignText: 'center'}}>
          <Skeleton animation="wave" height={10} width="100%"  />
                    </div>
      </div>
            :
            <div className={classes.root}>
      <div className={classes.avatarSection}>
        <Avatar alt={user.username} src={user.profileImageUrl}/>
      </div>
                <div className={classes.inputSection}>
        <div align='left'>
          {comment.hashtags.map(hashtag => <Chip label={hashtag.name} />)}
          {comment.persontags.map(persontag => <Chip label={'@'+persontag.username} />)}
        </div>
                    <Input
                        defaultValue={comment.text}
                        className={classes.inputRoot}
          multiline
                        inputProps={{
                            'aria-label': 'description',
                             classes: {
                                 input: classes.input,
                             },
                        }}
                        onChange={e => setInput(e.target.value)}
          onKeyDown={ev => {
            /*
            if(ev.key === 'Enter'){
              handleEditSubmit();
            }
            */
            if(ev.keyCode === 27){
              handleEditFormCancle()
            }
          }}
                    />
                    <div className={classes.buttons} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 6 }}>
                        <Tooltip title="Save">
                          <IconButton size="small" aria-label="Save" onClick={handleEditSubmit}>
                            <SendIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Cancel">
                          <IconButton size="small" aria-label="Cancel" onClick={handleEditFormCancle}>
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                    </div>
                </div>
            </div>
        }
    </Root>
  );
}
				


